// Generated by PEG.js v0.11.0-dev.325, https://pegjs.org/

function peg$subclass(child, parent) {
  function C() { this.constructor = child; }
  C.prototype = parent.prototype;
  child.prototype = new C();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message = message;
  this.expected = expected;
  this.found = found;
  this.location = location;
  this.name = "SyntaxError";

  // istanbul ignore next
  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function(expectation) {
      return "\"" + literalEscape(expectation.text) + "\"";
    },

    class: function(expectation) {
      var escapedParts = expectation.parts.map(function(part) {
        return Array.isArray(part)
          ? classEscape(part[0]) + "-" + classEscape(part[1])
          : classEscape(part);
      });

      return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
    },

    any: function() {
      return "any character";
    },

    end: function() {
      return "end of input";
    },

    other: function(expectation) {
      return expectation.description;
    },

    not: function(expectation) {
      return "not " + describeExpectation(expectation.expected);
    }
  };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s
      .replace(/\\/g, "\\\\")
      .replace(/"/g,  "\\\"")
      .replace(/\0/g, "\\0")
      .replace(/\t/g, "\\t")
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replace(/[\x00-\x0F]/g,          function(ch) { return "\\x0" + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return "\\x"  + hex(ch); });
  }

  function classEscape(s) {
    return s
      .replace(/\\/g, "\\\\")
      .replace(/\]/g, "\\]")
      .replace(/\^/g, "\\^")
      .replace(/-/g,  "\\-")
      .replace(/\0/g, "\\0")
      .replace(/\t/g, "\\t")
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replace(/[\x00-\x0F]/g,          function(ch) { return "\\x0" + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return "\\x"  + hex(ch); });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = expected.map(describeExpectation);
    var i, j;

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ")
          + ", or "
          + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== undefined ? options : {};

  var peg$FAILED = {};

  var peg$startRuleFunctions = { Frogram: peg$parseFrogram, Lines: peg$parseLines };
  var peg$startRuleFunction = peg$parseFrogram;

  var peg$c0 = "onTick";
  var peg$c1 = "{";
  var peg$c2 = "}";
  var peg$c3 = ";";
  var peg$c4 = "exec";
  var peg$c5 = "moveUp";
  var peg$c6 = "moveDown";
  var peg$c7 = "moveLeft";
  var peg$c8 = "moveRight";
  var peg$c9 = "if";
  var peg$c10 = "(";
  var peg$c11 = ")";
  var peg$c12 = "else";
  var peg$c13 = "!";
  var peg$c14 = "()";
  var peg$c15 = "&&";
  var peg$c16 = "||";
  var peg$c17 = "isGoalUp";
  var peg$c18 = "isRiverUp";
  var peg$c19 = "is";
  var peg$c20 = "Car";
  var peg$c21 = "Log";
  var peg$c22 = "Wall";
  var peg$c23 = "Up";
  var peg$c24 = "Right";
  var peg$c25 = "Down";
  var peg$c26 = "Left";
  var peg$c27 = "true";
  var peg$c28 = "false";

  var peg$r0 = /^[ \t\n\r]/;
  var peg$r1 = /^[0-9]/;

  var peg$e0 = peg$literalExpectation("onTick", false);
  var peg$e1 = peg$literalExpectation("{", false);
  var peg$e2 = peg$literalExpectation("}", false);
  var peg$e3 = peg$literalExpectation(";", false);
  var peg$e4 = peg$literalExpectation("exec", false);
  var peg$e5 = peg$literalExpectation("moveUp", false);
  var peg$e6 = peg$literalExpectation("moveDown", false);
  var peg$e7 = peg$literalExpectation("moveLeft", false);
  var peg$e8 = peg$literalExpectation("moveRight", false);
  var peg$e9 = peg$literalExpectation("if", false);
  var peg$e10 = peg$literalExpectation("(", false);
  var peg$e11 = peg$literalExpectation(")", false);
  var peg$e12 = peg$literalExpectation("else", false);
  var peg$e13 = peg$literalExpectation("!", false);
  var peg$e14 = peg$literalExpectation("()", false);
  var peg$e15 = peg$literalExpectation("&&", false);
  var peg$e16 = peg$literalExpectation("||", false);
  var peg$e17 = peg$literalExpectation("isGoalUp", false);
  var peg$e18 = peg$literalExpectation("isRiverUp", false);
  var peg$e19 = peg$literalExpectation("is", false);
  var peg$e20 = peg$literalExpectation("Car", false);
  var peg$e21 = peg$literalExpectation("Log", false);
  var peg$e22 = peg$literalExpectation("Wall", false);
  var peg$e23 = peg$literalExpectation("Up", false);
  var peg$e24 = peg$literalExpectation("Right", false);
  var peg$e25 = peg$literalExpectation("Down", false);
  var peg$e26 = peg$literalExpectation("Left", false);
  var peg$e27 = peg$otherExpectation("whitespace");
  var peg$e28 = peg$otherExpectation("boolean");

  var peg$f0 = function(body) { return { type: 'frogram', body }; };
  var peg$f1 = function(l) { return l };
  var peg$f2 = function(ls) { return ls; };
  var peg$f3 = function(operation) { return operation; };
  var peg$f4 = function(operations) { return operations; };
  var peg$f5 = function(name) { return { type: 'command', name }; };
  var peg$f6 = function(p, ifBody, elseBody) {
      elseBody = elseBody || [];
      return { type: 'IfStatement', condition: p, ifBody, elseBody };
    };
  var peg$f7 = function(operations) {
      if (operations.length <= 0) return null;
      return operations;
    };
  var peg$f8 = function(p) { return '(' + p + ')' };
  var peg$f9 = function(p, l, p2) { return l + p2; };
  var peg$f10 = function(p, ps) { return p + ps.join('') };
  var peg$f11 = function(nots, name) { return name; };
  var peg$f12 = function(nots, bool) { return bool };
  var peg$f13 = function(nots, p) {
                 const q = notElim(nots) + p;
                 if (['true', '!false'].includes(q)) return 'true';
                 if (['false', '!true'].includes(q)) return 'false';
                 return q;
               };
  var peg$f14 = function(o) { return o };
  var peg$f15 = function() { return text() };
  var peg$f16 = function() { return parseInt(text(), 10); };
  var peg$f17 = function() { return text(); };

  var peg$currPos = 0;
  var peg$savedPos = 0;
  var peg$posDetailsCache = [{ line: 1, column: 1 }];
  var peg$expected = [];
  var peg$silentFails = 0;

  var peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function offset() {
    return peg$savedPos;
  }

  function range() {
    return [peg$savedPos, peg$currPos];
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text: text, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description: description };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos];
    var p;

    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;

      return details;
    }
  }

  var peg$VALIDFILENAME = typeof options.filename === "string" && options.filename.length > 0;
  function peg$computeLocation(startPos, endPos) {
    var loc = {};

    if ( peg$VALIDFILENAME ) loc.filename = options.filename;

    var startPosDetails = peg$computePosDetails(startPos);
    loc.start = {
      offset: startPos,
      line: startPosDetails.line,
      column: startPosDetails.column
    };

    var endPosDetails = peg$computePosDetails(endPos);
    loc.end = {
      offset: endPos,
      line: endPosDetails.line,
      column: endPosDetails.column
    };

    return loc;
  }

  function peg$begin() {
    peg$expected.push({ pos: peg$currPos, variants: [] });
  }

  function peg$expect(expected) {
    var top = peg$expected[peg$expected.length - 1];

    if (peg$currPos < top.pos) { return; }

    if (peg$currPos > top.pos) {
      top.pos = peg$currPos;
      top.variants = [];
    }

    top.variants.push(expected);
  }

  function peg$end(invert) {
    var expected = peg$expected.pop();
    var top = peg$expected[peg$expected.length - 1];
    var variants = expected.variants;

    if (top.pos !== expected.pos) { return; }

    if (invert) {
      variants = variants.map(function(e) {
        return e.type === "not" ? e.expected : { type: "not", expected: e };
      });
    }

    Array.prototype.push.apply(top.variants, variants);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$buildError() {
    var expected = peg$expected[0];
    var failPos = expected.pos;

    return peg$buildStructuredError(
      expected.variants,
      failPos < input.length ? input.charAt(failPos) : null,
      failPos < input.length
        ? peg$computeLocation(failPos, failPos + 1)
        : peg$computeLocation(failPos, failPos)
    );
  }

  function peg$parseFrogram() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    rule$expects(peg$e0);
    if (input.substr(peg$currPos, 6) === peg$c0) {
      s1 = peg$c0;
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      rule$expects(peg$e1);
      if (input.charCodeAt(peg$currPos) === 123) {
        s3 = peg$c1;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        s5 = peg$parseLines();
        s6 = peg$parse_();
        rule$expects(peg$e2);
        if (input.charCodeAt(peg$currPos) === 125) {
          s7 = peg$c2;
          peg$currPos++;
        } else {
          s7 = peg$FAILED;
        }
        if (s7 !== peg$FAILED) {
          s8 = peg$parse_();
          peg$savedPos = s0;
          s0 = peg$f0(s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLines() {
    var s0, s1, s2, s3, s4, s5;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$currPos;
    s3 = peg$parse_();
    s4 = peg$parseLine();
    if (s4 !== peg$FAILED) {
      s5 = peg$parse_();
      peg$savedPos = s2;
      s2 = peg$f1(s4);
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$currPos;
      s3 = peg$parse_();
      s4 = peg$parseLine();
      if (s4 !== peg$FAILED) {
        s5 = peg$parse_();
        peg$savedPos = s2;
        s2 = peg$f1(s4);
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    }
    peg$savedPos = s0;
    s1 = peg$f2(s1);
    s0 = s1;

    return s0;
  }

  function peg$parseLine() {
    var s0, s1, s2;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    s1 = peg$parseExecCommand();
    if (s1 !== peg$FAILED) {
      rule$expects(peg$e3);
      if (input.charCodeAt(peg$currPos) === 59) {
        s2 = peg$c3;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f3(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseIfStatement();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f4(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parseExecCommand() {
    var s0, s1, s2, s3;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    rule$expects(peg$e4);
    if (input.substr(peg$currPos, 4) === peg$c4) {
      s1 = peg$c4;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      s3 = peg$parseCommandName();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f5(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseCommandName() {
    var s0;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    rule$expects(peg$e5);
    if (input.substr(peg$currPos, 6) === peg$c5) {
      s0 = peg$c5;
      peg$currPos += 6;
    } else {
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      rule$expects(peg$e6);
      if (input.substr(peg$currPos, 8) === peg$c6) {
        s0 = peg$c6;
        peg$currPos += 8;
      } else {
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        rule$expects(peg$e7);
        if (input.substr(peg$currPos, 8) === peg$c7) {
          s0 = peg$c7;
          peg$currPos += 8;
        } else {
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          rule$expects(peg$e8);
          if (input.substr(peg$currPos, 9) === peg$c8) {
            s0 = peg$c8;
            peg$currPos += 9;
          } else {
            s0 = peg$FAILED;
          }
        }
      }
    }

    return s0;
  }

  function peg$parseIfStatement() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    rule$expects(peg$e9);
    if (input.substr(peg$currPos, 2) === peg$c9) {
      s1 = peg$c9;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      rule$expects(peg$e10);
      if (input.charCodeAt(peg$currPos) === 40) {
        s3 = peg$c10;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        s5 = peg$parsePredicate();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse_();
          rule$expects(peg$e11);
          if (input.charCodeAt(peg$currPos) === 41) {
            s7 = peg$c11;
            peg$currPos++;
          } else {
            s7 = peg$FAILED;
          }
          if (s7 !== peg$FAILED) {
            s8 = peg$parse_();
            rule$expects(peg$e1);
            if (input.charCodeAt(peg$currPos) === 123) {
              s9 = peg$c1;
              peg$currPos++;
            } else {
              s9 = peg$FAILED;
            }
            if (s9 !== peg$FAILED) {
              s10 = peg$parse_();
              s11 = peg$parseLines();
              if (s11 !== peg$FAILED) {
                s12 = peg$parse_();
                rule$expects(peg$e2);
                if (input.charCodeAt(peg$currPos) === 125) {
                  s13 = peg$c2;
                  peg$currPos++;
                } else {
                  s13 = peg$FAILED;
                }
                if (s13 !== peg$FAILED) {
                  s14 = peg$parse_();
                  s15 = peg$parseElseStatement();
                  if (s15 === peg$FAILED) {
                    s15 = null;
                  }
                  peg$savedPos = s0;
                  s0 = peg$f6(s5, s11, s15);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseElseStatement() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    rule$expects(peg$e12);
    if (input.substr(peg$currPos, 4) === peg$c12) {
      s1 = peg$c12;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      rule$expects(peg$e1);
      if (input.charCodeAt(peg$currPos) === 123) {
        s3 = peg$c1;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();
        s5 = peg$parseLines();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse_();
          rule$expects(peg$e2);
          if (input.charCodeAt(peg$currPos) === 125) {
            s7 = peg$c2;
            peg$currPos++;
          } else {
            s7 = peg$FAILED;
          }
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f7(s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePredicate() {
    var s0, s1, s2, s3, s4, s5;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    s1 = peg$parse_PREDICATE();
    if (s1 === peg$FAILED) {
      s1 = peg$currPos;
      rule$expects(peg$e10);
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c10;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsePredicate();
        if (s3 !== peg$FAILED) {
          rule$expects(peg$e11);
          if (input.charCodeAt(peg$currPos) === 41) {
            s4 = peg$c11;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            peg$savedPos = s1;
            s1 = peg$f8(s3);
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse_LOGICAL_OPERATOR();
      if (s4 !== peg$FAILED) {
        s5 = peg$parsePredicate();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s3;
          s3 = peg$f9(s1, s4, s5);
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse_LOGICAL_OPERATOR();
        if (s4 !== peg$FAILED) {
          s5 = peg$parsePredicate();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s3;
            s3 = peg$f9(s1, s4, s5);
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f10(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parse_PREDICATE() {
    var s0, s1, s2, s3, s4, s5, s6;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    s1 = [];
    rule$expects(peg$e13);
    if (input.charCodeAt(peg$currPos) === 33) {
      s2 = peg$c13;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
    }
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      rule$expects(peg$e13);
      if (input.charCodeAt(peg$currPos) === 33) {
        s2 = peg$c13;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
      }
    }
    s2 = peg$parse_();
    s3 = peg$currPos;
    s4 = peg$parsePredicateName();
    if (s4 !== peg$FAILED) {
      s5 = peg$parse_();
      rule$expects(peg$e14);
      if (input.substr(peg$currPos, 2) === peg$c14) {
        s6 = peg$c14;
        peg$currPos += 2;
      } else {
        s6 = peg$FAILED;
      }
      if (s6 !== peg$FAILED) {
        peg$savedPos = s3;
        s3 = peg$f11(s1, s4);
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
    } else {
      peg$currPos = s3;
      s3 = peg$FAILED;
    }
    if (s3 === peg$FAILED) {
      s3 = peg$currPos;
      s4 = peg$parseBoolean();
      if (s4 !== peg$FAILED) {
        peg$savedPos = s3;
        s4 = peg$f12(s1, s4);
      }
      s3 = s4;
    }
    if (s3 !== peg$FAILED) {
      peg$savedPos = s0;
      s0 = peg$f13(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parse_LOGICAL_OPERATOR() {
    var s0, s1, s2, s3;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    s1 = peg$parse_();
    rule$expects(peg$e15);
    if (input.substr(peg$currPos, 2) === peg$c15) {
      s2 = peg$c15;
      peg$currPos += 2;
    } else {
      s2 = peg$FAILED;
    }
    if (s2 === peg$FAILED) {
      rule$expects(peg$e16);
      if (input.substr(peg$currPos, 2) === peg$c16) {
        s2 = peg$c16;
        peg$currPos += 2;
      } else {
        s2 = peg$FAILED;
      }
    }
    if (s2 !== peg$FAILED) {
      s3 = peg$parse_();
      peg$savedPos = s0;
      s0 = peg$f14(s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePredicateName() {
    var s0, s1, s2, s3;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    rule$expects(peg$e17);
    if (input.substr(peg$currPos, 8) === peg$c17) {
      s0 = peg$c17;
      peg$currPos += 8;
    } else {
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      rule$expects(peg$e18);
      if (input.substr(peg$currPos, 9) === peg$c18) {
        s0 = peg$c18;
        peg$currPos += 9;
      } else {
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        rule$expects(peg$e19);
        if (input.substr(peg$currPos, 2) === peg$c19) {
          s1 = peg$c19;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          rule$expects(peg$e20);
          if (input.substr(peg$currPos, 3) === peg$c20) {
            s2 = peg$c20;
            peg$currPos += 3;
          } else {
            s2 = peg$FAILED;
          }
          if (s2 === peg$FAILED) {
            rule$expects(peg$e21);
            if (input.substr(peg$currPos, 3) === peg$c21) {
              s2 = peg$c21;
              peg$currPos += 3;
            } else {
              s2 = peg$FAILED;
            }
            if (s2 === peg$FAILED) {
              rule$expects(peg$e22);
              if (input.substr(peg$currPos, 4) === peg$c22) {
                s2 = peg$c22;
                peg$currPos += 4;
              } else {
                s2 = peg$FAILED;
              }
            }
          }
          if (s2 !== peg$FAILED) {
            rule$expects(peg$e23);
            if (input.substr(peg$currPos, 2) === peg$c23) {
              s3 = peg$c23;
              peg$currPos += 2;
            } else {
              s3 = peg$FAILED;
            }
            if (s3 === peg$FAILED) {
              rule$expects(peg$e24);
              if (input.substr(peg$currPos, 5) === peg$c24) {
                s3 = peg$c24;
                peg$currPos += 5;
              } else {
                s3 = peg$FAILED;
              }
              if (s3 === peg$FAILED) {
                rule$expects(peg$e25);
                if (input.substr(peg$currPos, 4) === peg$c25) {
                  s3 = peg$c25;
                  peg$currPos += 4;
                } else {
                  s3 = peg$FAILED;
                }
                if (s3 === peg$FAILED) {
                  rule$expects(peg$e26);
                  if (input.substr(peg$currPos, 4) === peg$c26) {
                    s3 = peg$c26;
                    peg$currPos += 4;
                  } else {
                    s3 = peg$FAILED;
                  }
                }
              }
            }
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f15();
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    return s0;
  }

  function peg$parse_() {
    var s0, s1;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    rule$expects(peg$e27);
    peg$silentFails++;
    s0 = [];
    if (peg$r0.test(input.charAt(peg$currPos))) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      if (peg$r0.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
      }
    }
    peg$silentFails--;

    return s0;
  }

  function peg$parseInteger() {
    var s0, s1, s2, s3;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    s0 = peg$currPos;
    s1 = peg$parse_();
    s2 = [];
    if (peg$r1.test(input.charAt(peg$currPos))) {
      s3 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s3 = peg$FAILED;
    }
    if (s3 !== peg$FAILED) {
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        if (peg$r1.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
        }
      }
    } else {
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      peg$savedPos = s0;
      s0 = peg$f16();
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseBoolean() {
    var s0, s1, s2;

    var rule$expects = function (expected) {
      if (peg$silentFails === 0) peg$expect(expected);
    }

    rule$expects(peg$e28);
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = peg$parse_();
    if (input.substr(peg$currPos, 4) === peg$c27) {
      s2 = peg$c27;
      peg$currPos += 4;
    } else {
      s2 = peg$FAILED;
    }
    if (s2 === peg$FAILED) {
      if (input.substr(peg$currPos, 5) === peg$c28) {
        s2 = peg$c28;
        peg$currPos += 5;
      } else {
        s2 = peg$FAILED;
      }
    }
    if (s2 !== peg$FAILED) {
      peg$savedPos = s0;
      s0 = peg$f17();
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$silentFails--;

    return s0;
  }


    const notElim = (nots) => Array.from({ length: nots.length % 2 }, () => '!').join('');


  peg$begin();
  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$expect(peg$endExpectation());
    }

    throw peg$buildError();
  }
}

export {
  peg$SyntaxError as SyntaxError,
  peg$parse as parse
};

export default {
  SyntaxError: peg$SyntaxError,
  parse: peg$parse
};
